import axios from 'axios'
import { ALTERAR_PRECO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function alterarRota (preco) {
  const url = `${URL}/preco/alterar`;
  return dispatch => axios.post(url, preco, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: ALTERAR_PRECO,
        payload: response
      })
  );
}
